module.exports = __webpack_public_path__ + "static/media/karak_logo_new.0e9542e3.png";